import React, { useState } from 'react';
import { YStack, XStack, SizableText, H4, Card, Button, TextArea } from 'tamagui';
import type { UIComponentContract } from '../../types/componentContract';

export const uiContract: UIComponentContract = {
  id: "post.composer",
  accepts: {
    capability: "create_post",
    shape: {
      content: "string",
      media: "array?",
      visibility: "string?"
    },
    required: ["content"],
    optional: ["media", "visibility"]
  },
  renders: "form",
  priority: 6,
  surface: "options"
};

interface PostComposerProps {
  data?: {
    content?: string;
    media?: string[];
    visibility?: string;
  };
  onSubmit?: (data: { content: string; media?: string[]; visibility?: string }) => void;
}

export const PostComposer: React.FC<PostComposerProps> = (props) => {
  const { data, onSubmit } = props || {};
  const [content, setContent] = useState(data?.content || '');
  const [visibility, setVisibility] = useState(data?.visibility || 'public');

  const handleSubmit = () => {
    if (content.trim() && onSubmit) {
      onSubmit({
        content: content.trim(),
        visibility
      });
      setContent(''); // Reset after submit
    }
  };

  return (
    <Card
      borderRadius={16}
      padding="$5"
      elevate
      backgroundColor="$background"
    >
      <YStack gap="$4">
        <H4 fontWeight="700">Create Post</H4>
        
        <TextArea
          placeholder="What's on your mind?"
          value={content}
          onChangeText={setContent}
          minHeight={120}
          backgroundColor="$gray2"
          borderRadius={8}
          padding="$3"
        />
        
        <XStack justifyContent="space-between" alignItems="center">
          <SizableText size="$3" color="$gray10">
            {content.length} characters
          </SizableText>
          
          <Button
            onPress={handleSubmit}
            disabled={!content.trim()}
            backgroundColor="$blue10"
            color="white"
            borderRadius={8}
            paddingHorizontal="$4"
          >
            <SizableText color="white" fontWeight="600">
              Post
            </SizableText>
          </Button>
        </XStack>
      </YStack>
    </Card>
  );
};

// Attach contract to component
PostComposer.uiContract = uiContract;

export default PostComposer;

